export const workflowComments = {
  createTitle: "Create comment",
  editTitle: "Update comment",
  createdText: "Comment has been created",
  updatedText: "Comment has been updated",
  inputPlaceholder: "Please enter your comment text here"
};
